<template>
<div class="my-company">

    <vue-headful
        title="TZ Design Box - Companies"
        description="TZ Design Box"
    />

    <div class="container">
        <div class="columns">
            <div class="column is-2 menu-vert">
                <MenuVert :currentactive="'companies'" />
            </div>
            <div class="column is-10" style="margin-top:25px;">
                <Breadcrumbs />
                <hr>
                <div class="content">
                    <h2>{{ $t("sub-companies") }}</h2>
                    <p>{{ $t("companies-overview-details") }}</p>

                    <b-field grouped>
                        <b-field
                            :type="{'is-danger': errors.has('search')}"
                            :message="errors.first('search')"
                            >
                            <b-input
                                type="text"
                                v-model="search"
                                name="search"
                                v-validate="'required'"
                                style="width:250px;"
                                @keyup.native.enter="searchCompany"
                            />
                            <p class="control">
                                <b-button type="is-primary" :disabled="search.length < 3" @click="searchCompany"
                                > {{ $t("search") }} </b-button><br><br>
                            </p>
                        </b-field>
                        <b-field>
                            <a class="button is-info" href="#current-company">{{ $t ('to-current-company') }}</a>
                        </b-field>
                    </b-field>
                    <div class="columns" style="font-weight:bold!important;">
                        <div class="column is-one-fifth is-6">{{ $t("name") }}</div>
                        <div class="column is-one-fifth is-1">{{ $t("customer-no") }}</div>
                        <div class="column is-one-fifth is-1">{{ $t("zip") }}</div>
                        <div class="column is-one-fifth is-2">{{ $t("city") }}</div>
                        <div class="column is-one-fifth is-1">{{ $t("zip") }}</div>
                    </div>
                    <div>
                        <TreeBrowser
                        :node="getCompanyRoot"
                        :cid="comp_id"
                        @shopAs="shopAs"
                        />
                        <b-loading :is-full-page="false" :active.sync="getCompaniesLoading">
                        </b-loading>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import MenuVert         from "@/components/MenuVert"
import Breadcrumbs      from "@/components/Breadcrumbs"
import TreeBrowser      from "./TreeBrowser"
import { mapGetters }   from "vuex"

export default {
    name: "Companies",
    props: ["cid"],
    computed: {
        ...mapGetters(["getCurrentCompany", "getCompanyRoot", "getCompaniesLoading"]),
        comp_id () {
            return parseInt (this.cid)
        },
    },
    data: function() {
        return { search: "", showAll: true}
    },
    components: { MenuVert,Breadcrumbs,TreeBrowser},
    methods: {
        searchCompany () {
            if (this.search.length >= 3) {
                var self = this;
                this.$store
                    .dispatch ("searchCompanies", {
                        self:    this,
                        search:  this.search,
                        company: this.cid
                    }).catch(error => {
                        self.$toastr ("error", error, "Failure")
                    })
            }
        },
        shopAs(id) {
            if (this.getCurrentCompany.lines.length > 1)
                this.$router.push ({ name: "select-line"})
            else {
                this.$buefy.toast.open ({
                    message: this.$i18n.t("Redirect to shop"),
                    type: 'is-info',
                    duration: 1000,
                    })
                this.$store.dispatch ("shopClicked", id)
            }

        },
        changeCurrentCompany (cid) {
            const self = this
            localStorage.setItem ("company", cid)
            this.$store.dispatch("callSubCompanies",   {self: self, company: cid})
            this.$store.dispatch("callCurrentCompany", {self: self, company: cid}).then ((r) => {
                const shopAs = localStorage.getItem ("triggerShopAs")
                if (shopAs) {
                    localStorage.removeItem ("triggerShopAs")
                    this.shopAs (cid)
                }
            })
        }
    },
    created() {
        this.changeCurrentCompany (this.cid)
    },
    watch : {
        '$route' (to, from) {
            let self = this
            if (from.params.cid != to.params.cid)
                this.changeCurrentCompany (to.params.cid)
            }
    }
}
</script>

<style>
.my-company {
    padding-bottom:50px;
}
.content {
    background-color: #fff !important;
    padding: 25px;
    box-shadow: 0 1px #ffffff inset, 0 1px 3px rgba(34, 25, 25, 0.4);
}
</style>